import $ from '@nuskin/nuskinjquery';
import {RunConfigService} from '@nuskin/ns-util';

let CurrencyService = function() {
    let byCountry = {},
        byCurrencyCode = {},
        runConfig = {};

    function init() {
        if (!Object.hasOwn(runConfig, 'country')) {
            runConfig = RunConfigService.getRunConfig();
        }
    }

    function getCurrency(country) {
        init();
        let currency = byCountry[country],
            baseUrl = runConfig.assessmentApp ? '' : runConfig.baseUrl;

        if (typeof baseUrl === "undefined") {
            baseUrl = "";
        }

        if (!currency) {
            $.ajax({
                type: "GET",
                url: baseUrl + '/content/configuration/currencies.service.' + country + '.json',
                dataType: "json",
                async: false,
                success: function(data) {
                    if (data[0]) {
                        currency = byCountry[country] = data[0];
                        setDefaults(currency);
                        byCurrencyCode[data[0].currencyCode] = data[0];
                    }
                },
                error: function(xhr) {
                    console.error("could not get the market's currency! error:"+xhr);
                }
            });
        }
        return currency;
    }

    function setDefaults(currency) {
        if (currency) {
            if (!currency.delimiter) {
                currency.delimiter = ',';
            }
            if (!currency.decimal) {
                currency.decimal = '.';
            }
        }
    }

    function getCountryKey(_country, _language) {
        init();
        let country,
            language;

        country = _country || runConfig.country;
        language = _language || runConfig.language;
        if (country === 'CA' && language === 'fr') {
            country = language + '_' + country;
        }

        return country;
    }

    function initAmount(amount) {
        // Make sure the amount is a number.
        let initializedNumber = parseFloat(amount);
        if (isNaN(initializedNumber)) {
            initializedNumber = 0.00;
        }
        return initializedNumber;
    }

    function applyAccuracyDelimiterDecimal(currency, amount) {
        let p = amount.toFixed(currency.accuracy).split("."),
            chars = p[0].split("").reverse(),
            newstr = '',
            count = 0;

        for (let x = 0; x < chars.length; x++) {
            count++;
            if (count%3 == 1 && count != 1) {
                // Add in the delimiter
                newstr = chars[x] + currency.delimiter + newstr;
            } else {
                newstr = chars[x] + newstr;
            }
        }

        // Add in the decimal
        let retVal = newstr;

        if (p[1] !== undefined) {
            retVal += currency.decimal + p[1];
        }

        return retVal;
    }

    function applySymbol(currency, amount) {
        if (currency.after === 'true'){
            amount = amount + currency.symbol;
        } else {
            if (amount < 0) {
                amount = `-${currency.symbol}${-amount}`;
            } else {
                amount = currency.symbol + amount;
            }

        }
        return amount;
    }

    function parseCurrencyStringToFloat(currencyString, thousandsDelimiter, currencySymbol) {

        if (!thousandsDelimiter) {
            thousandsDelimiter = getCurrency(runConfig.country).delimiter;
        }
        if (!currencySymbol) {
            currencySymbol = getCurrency(runConfig.country).symbol ? getCurrency(runConfig.country).symbol : '';
        }
        /* eslint-disable-next-line */
        const delimiterEscaped = thousandsDelimiter.replace(/\./g, '\\\.')
        const RE = RegExp
        const charactersToRemove = new RE(delimiterEscaped + '|' + currencySymbol, 'g');

        return parseFloat(
            currencyString
                .replace(charactersToRemove, '')    // remove the delimiters, they confuse parseFloat
                .replace(',', '.')              // replace any remaining commas with periods. If these exist then we are in a market with non-regular decimals
                .replace(/[^\d.]/g, '')         // remove extraneous characters
        )
    }

    let format = function(amount, country, language) {
        let currency,
            formatted = amount;

        currency = getCurrency(getCountryKey(country, language));

        if (currency) {
            formatted = initAmount(amount);
            formatted = applyAccuracyDelimiterDecimal(currency, formatted); // Busted for VN
            formatted = applySymbol(currency, formatted);
        }
        return formatted;
    };

    return {
        format: format,
        getCurrency: getCurrency,
        parseCurrencyStringToFloat: parseCurrencyStringToFloat/*,
        getCurrencySymbol: getCurrencySymbol*/
    }
}();

export default CurrencyService;
